import { render, staticRenderFns } from "./FulfillmentPrivilegeList.vue?vue&type=template&id=2641e092&scoped=true&"
import script from "./FulfillmentPrivilegeList.vue?vue&type=script&lang=js&"
export * from "./FulfillmentPrivilegeList.vue?vue&type=script&lang=js&"
import style0 from "./FulfillmentPrivilegeList.vue?vue&type=style&index=0&id=2641e092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2641e092",
  null
  
)

export default component.exports